import {BUSCAR_ITINERARIOS, LIMPAR_ITINERARIOS, EXCLUIR_ITINERARIO} from '../../actions/types'

const initialState = undefined;

export default function reducerBuscarTrechos (state = {}, action = initialState) {
  switch (action.type) {
    case BUSCAR_ITINERARIOS: {
      const itinerarios = action.payload.data;

      if (itinerarios) {
        return itinerarios
      }
      return []
    }

    case EXCLUIR_ITINERARIO: {
      if (Array.isArray(state)) {
        return state.filter(it => it.id !== action.payload.idItinerario);
      }
      return state;
    }

    case LIMPAR_ITINERARIOS:
      return {};

    default: {
      return state
    }
  }
}
